import BaseModel from '../core/BaseModel'
export default class HistoryExportModel extends BaseModel {
    constructor() {
        super({ 
                name: "history_export",
                tableName: 'core_history_export',
                display_key: 'id'
            },
            {
              id: { 
                name: 'id',
                type: "Bigint,", 
                label: 'ID', 
                primaryKey: true,
                display: false
              },
              created_at_tz: { 
                name: 'created_at_tz', 
                type: "CustomDateTime", 
                label: 'Thời gian xuất báo cáo',
                width: 15,
                filter: { type: 'DateRange', match: 'custom'}
              },
              date_filter_text: { 
                name: 'date_filter_text', 
                type: "String", 
                label: 'Thời gian của dữ liệu',
                width: 15,
              },
              name: { 
                name: 'name', 
                type: "String", 
                label: 'Tên báo cáo',
                width: 15,
                filter: { type: 'input',  match: 'custom'}
              },
              user_id: { 
                name: 'user_id', 
                type: "Bigint,", 
                label: 'USER ID', 
                display: false
              },
              key_file: { 
                name: 'key_file', 
                type: 'Text', 
                label: 'Key s3', 
                display: false
              },
              column_text: { 
                name: 'column_text', 
                type: "String", 
                label: 'Số lượng cột',
                width: 10,
                // sortable: true
              },
              process_status: {
                name: 'process_status', 
                label: 'Trạng thái hoạt động', 
                type: "Selection",  
                dataType: 'Label',  
                class: 'center', 
                width: 15,
                options: [{ value: 0, label: 'Đang xuất dữ liệu',style: 'color: #0099FF; font-weight: 500;'}, { value: 1, label: 'Thành công',style: 'color: #009900; font-weight: 500;'},{ value: 2, label: 'Thất bại',style: 'color: #CC0000; font-weight: 500;'}],
                filter: { type: 'select', display: false, optionLabel: 'label', optionKey: 'value', match: 'equals' }
              },
            
        },)
    }

}